import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TableHeadingsService {

  public paymentsTableHeadings: string[] = [
    "Factura",
    "Documento",
    "Deudor",
    "Valor pago",
    "Valor a remitir",
    "Fecha depósito",
  ];
  
  public billsToOnlinePaymentTableHeadings: string[] = [
    "Número factura",
    "Referencia pago",
    "Fecha radicación",
    "Fecha vencimiento",
    "Mora final",
    
    "Pagar",
    "Seleccione medio de pago"
  ];

}
